var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"back"}},[_c('van-nav-bar',{attrs:{"title":_vm.title,"left-text":"返回","left-arrow":""},on:{"click-left":_vm.onClickLeft,"click-right":_vm.onClickRight},scopedSlots:_vm._u([{key:"right",fn:function(){return [_c('van-icon',{attrs:{"name":"home-o","size":"24"}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }